/**
 * Mask configurations used in the [mask] directive for schedules D and H step.
 * Documentation: https://imask.js.org/guide.html
 */
export class SchedulesDAndHMaskConfig {
    public static readonly heightOfStructure = {
        mask: Number,
        scale: 1,
        signed: true,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: -999999.9,
        max: 999999.9,
        radix: '.',
        lazy: false,
    };

    public static readonly towerRegistrationNumber = {
        mask: [{ mask: '0000000' }],
    };
}
